export default {
    getCareTeam(state) {
        
        return state.episode.care_teams.filter(item => item.action !== 'D')
    },
}